export const OurPurchaseProcess = () => {
  const steps = [
    {
      number: '01',
      title: 'Initial Contact',
      description: 'Share information about your mixed-use property including residential units and commercial spaces.',
      timeline: 'Day 1'
    },
    {
      number: '02',
      title: 'Comprehensive Review',
      description: 'We analyze both residential and commercial components, reviewing rent rolls, leases, and financials.',
      timeline: 'Days 2-7'
    },
    {
      number: '03',
      title: 'Property Inspection',
      description: 'We tour the property to assess both residential and commercial spaces, systems, and condition.',
      timeline: 'Days 7-14'
    },
    {
      number: '04',
      title: 'Cash Offer',
      description: 'We present a comprehensive offer that properly values both residential and commercial income streams.',
      timeline: 'Days 14-21'
    },
    {
      number: '05',
      title: 'Due Diligence',
      description: 'We conduct thorough due diligence on all aspects of the property with minimal disruption.',
      timeline: 'Days 21-40'
    },
    {
      number: '06',
      title: 'Closing',
      description: 'We close on your timeline, typically within 30-45 days. You receive full payment at closing.',
      timeline: 'Days 30-45'
    }
  ];

  return (
    <section id="our-process" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Our Purchase Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We've streamlined the acquisition process for mixed-use properties to handle their complexity efficiently while making the sale as easy as possible for you.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 relative">
              <div className="text-6xl font-bold text-teal-500/20 absolute top-4 right-4">
                {step.number}
              </div>
              <div className="relative z-10">
                <div className="inline-block bg-teal-500 text-white px-4 py-1 rounded-full text-sm font-semibold mb-4">
                  {step.timeline}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-900">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="aspect-[4/3] rounded-xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/6fe7b526fe7be18a2a578a0560fd3ccb.jpg"
                  alt="Closing Process"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">Why Our Process Works</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-lightbulb-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">Specialized Expertise</h4>
                    <p className="text-gray-600">We understand both residential and commercial real estate, essential for mixed-use properties.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-money-dollar-circle-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">All-Cash Offers</h4>
                    <p className="text-gray-600">No financing contingencies mean certain closing and peace of mind.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-speed-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">Efficient Timeline</h4>
                    <p className="text-gray-600">We close in 30-45 days, much faster than traditional mixed-use sales.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">Minimal Disruption</h4>
                    <p className="text-gray-600">We respect your tenants and conduct due diligence with minimal impact on operations.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};